import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';
import { SessionExpireComponent } from '../session-expire/session-expire.component';
import { SessionExpireEvent, SessionExpireProgressBarEvent } from "../service/events";
import { EventService } from '../service/event.service';

@Injectable({
  providedIn: 'root'
})

export class IntervalSessionService {

  subSessionExpire: Subscription;

  dialogOpen: boolean = false;

  //1800000 milliseconds 1800 seconds in 30 minutes
  sessionExpires: number = 1800000;

  //test 300000 milliseconds in 5 minutes
  //sessionExpires : number = 300000;

  //1500000 milliseconds 1500 seconds in 25 minutes
  sessionExpireNotify: number = 1500000;

  //test 120000 milliseconds in 2 minutes
  //sessionExpireNotify : number = 120000;

  //60000 milliseconds 60 seconds 1 minute
  emitNotify: number = 60000;

  constructor(private dialog: MatDialog, private eventBus: EventService) {
    this.initialize();
    this.eventBus.on(
      SessionExpireEvent,
      (event): void => {
        setTimeout(() => {
          if ("Extend Session" == event.payload.text || "New Session" == event.payload.text) {
            this.initialize();
          } else if ("Cancel Session" == event.payload.text) {
            this.dialogOpen = false;
          }
        });
      }
    );
  }

  openSessionExpireFileDialog() {
    const dialogSessionExpireRef = this.dialog.open(SessionExpireComponent, {
      width: '550px'
    });

    dialogSessionExpireRef.afterClosed().subscribe(() => {
      //Session was closed
    });
  }

  initialize(): void {
    if (this.subSessionExpire) {
      this.subSessionExpire.unsubscribe();
    }
    this.subSessionExpire = timer(this.sessionExpireNotify, this.emitNotify).subscribe(val => this.sessionExpireNotification(val));
  }

  sessionExpireNotification(val: number) {
    if (!this.dialogOpen) {
      this.openSessionExpireFileDialog();
      this.dialogOpen = true;
    }
    const notificationTimeMinutes = (this.sessionExpires - this.sessionExpireNotify) / this.emitNotify;
    const minutesLeft = notificationTimeMinutes - val;
    const expiredTime = val * this.emitNotify;
    const timeLeft = this.sessionExpires - (this.sessionExpireNotify + expiredTime);
    if (timeLeft > 0) {
      let progress = ((this.sessionExpireNotify + expiredTime) / this.sessionExpires) * 100;
      setTimeout(() => {
        this.eventBus.emit(new SessionExpireProgressBarEvent({ progress: progress, minutesLeft: minutesLeft }));
      }, 100);
    } else {
      this.subSessionExpire.unsubscribe();
      this.dialogOpen = false;
      this.eventBus.emit(new SessionExpireEvent({ text: "End Session" }));
    }
  }

}